(function () {
  class SerotonCard {
    constructor(el) {
      this.el = el;
      this.tabs      = Array.from(el.querySelectorAll('.serotonCard__tab'));
      this.panels    = Array.from(el.querySelectorAll('.serotonCard__panel'));
      this.images    = Array.from(el.querySelectorAll('.serotonCard__image'));
      this.bgs       = Array.from(el.querySelectorAll('.serotonCard__bg'));
      this.tabsEl      = el.querySelector('.serotonCard__tabs');
      this.scrollTrack = el.querySelector('.serotonCard__scrollTrack');
      this.scrollThumb = el.querySelector('.serotonCard__scrollThumb');

      if (!this.tabs.length) return;

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.activate(parseInt(tab.dataset.cardTab, 10)));
      });

      if (this.tabsEl && this.scrollThumb) {
        this.updateScrollThumb();
        this.tabsEl.addEventListener('scroll', () => this.updateScrollThumb(), { passive: true });
        window.addEventListener('resize', () => this.updateScrollThumb(), { passive: true });
      }
    }

    updateScrollThumb() {
      const el = this.tabsEl;
      const scrollable = el.scrollWidth - el.clientWidth;
      if (scrollable <= 0) {
        this.scrollTrack.style.display = 'none';
        return;
      }
      this.scrollTrack.style.display = '';
      const ratio = el.clientWidth / el.scrollWidth;
      const thumbW = Math.max(ratio * 100, 10);
      const thumbLeft = (el.scrollLeft / scrollable) * (100 - thumbW);
      this.scrollThumb.style.width = thumbW + '%';
      this.scrollThumb.style.left  = thumbLeft + '%';
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('serotonCard__tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('serotonCard__panel--active', i === index);
      });

      this.images.forEach((img, i) => {
        img.classList.toggle('serotonCard__image--active', i === index);
      });

      this.bgs.forEach((bg, i) => {
        bg.classList.toggle('serotonCard__bg--active', i === index);
      });
    }
  }

  document.querySelectorAll('.serotonCard').forEach(el => new SerotonCard(el));
})();
